import { useEffect } from 'react'

const useDelay = (callback, delay) => {
    useEffect(() => {
        const handler = setTimeout(() => {
            if (callback) {
                callback()
            }
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [])
}

export default useDelay
